var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorybook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "150.000000pt",
    height: "150.000000pt",
    viewBox: "0 0 150.000000 150.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,150.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1140 1370 c0 -49 -4 -90 -9 -90 -4 0 -20 9 -35 21 l-26 20 -29 -20 c-47 -34 -51 -29 -51 62 l0 82 -107 -6 c-60 -4 -236 -15 -393 -24 -199 -13 -292 -22 -307 -32 -22 -13 -23 -19 -23 -145 0 -73 7 -294 14 -493 8 -198 17 -414 19 -480 2 -66 9 -130 15 -142 16 -28 30 -31 287 -42 757 -35 744 -35 765 -16 20 18 20 34 20 691 l0 673 -22 15 c-13 9 -43 16 -70 16 l-48 0 0 -90z m-243 -178 c53 -28 96 -81 117 -144 18 -55 21 -114 7 -122 -15 -10 -157 -19 -184 -13 -20 6 -25 14 -30 54 -6 56 -28 77 -72 68 -39 -7 -58 -32 -51 -69 9 -43 29 -61 131 -117 166 -92 214 -150 223 -269 8 -117 -42 -195 -158 -245 -63 -28 -225 -26 -291 3 -93 40 -149 132 -149 242 0 34 4 50 16 54 22 9 187 7 200 -2 6 -4 13 -28 16 -54 7 -61 21 -78 67 -78 45 0 61 14 61 56 0 45 -31 78 -122 131 -122 70 -172 114 -203 177 -23 47 -27 66 -23 118 7 113 60 185 165 224 60 22 226 14 280 -14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorybook);
export default __webpack_public_path__ + "static/media/storybook.8e09c70a98dfb8f5677ff951d92d6010.svg";
export { ForwardRef as ReactComponent };